/* Package JSON Import will be here */
import React from "react";
import { Header, Segment, Button, Icon, Modal, Table, Form, TextArea, Dropdown, Checkbox, Input } from 'semantic-ui-react';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import ImageUploading from "react-images-uploading";
/* Package JSON Import will be here */

/* Project Import will be here */
import { Constants } from "../../config/appConstants";
import AttachmentViewer from "../sharedComponent/attachmentViewer/attachmentViewer.Container";
import NoResultFound from "../sharedComponent/noResultFound";
import Loader from "../sharedComponent/loader/loader";
import * as utility from '../../services/utility';
import SelectTMVoucherModal from "./TMVoucher/TMVoucherComponents/SelectTMVoucherModal";
import ConfirmationPopup from "./TMVoucher/TMVoucherComponents/ConfirmationPopup";
import { RenderAttestation } from "./Attestation/RenderAttestation";
import { TimeCardStatus } from "./TimeCardCommons/TimeCardStatus";
/* Project Import will be here */

const TimeCardComponent = props => {
    let count = 0;
    const timeRecordProcessedStatus = [Constants.PROCESSED_STATUS].map(a => a.toLowerCase());

    return (
        <Segment.Group>
            <Segment className="stickyHeader">
                <Header as="h3" size='medium' className="d-flex align-items justify-content-between">
                    <div>
                        <Button style={{ visibility: props.timeCard.selectedTimeRecordsForDelete.every(a => !a.IsDelete) || (props.timeCard.isDeleteIconClicked) ? "visible" : "hidden" }} className="borderRadius thirdPartyColor whiteSpace " fluid size='small' onClick={() => (props.timeCard.selectedTimeRecordsForDelete.length === 0) && props.submitTimeCard()}>Submit </Button>
                    </div>
                    Timecard
                    <div>
                        <Button primary className="mr-1" size='mini' circular icon='sync' onClick={() => props.onSyncButton()} />
                        <Button primary size='mini' circular icon='question' onClick={() => props.onClickHelp()} />
                    </div>
                </Header>
                <Header as="h2" size='tiny' className='layoutStyle d-flex align-items justify-content-between'>
                    <MuiPickersUtilsProvider utils={DateFnsUtils} >
                        <KeyboardDatePicker className="timeCardDate"
                            placeholder="MM/dd/yyyy"
                            value={props.timeCard.selectedDate}
                            onChange={date => props.handleDateChange(date)}
                            inputProps={{ readOnly: true }}
                            format="MM/dd/yyyy"
                            minDate={props.timeCard.weekStartDate}
                            maxDate={props.timeCard.weekEndingDate}
                            open={props.timeCard.isDatePickerOpen}
                            onClick={props.handleDatePickerOpenAndClose}
                            onClose={() => props.handleDatePickerOpenAndClose(true)}
                        />
                    </MuiPickersUtilsProvider>
                    <div className='d-flex align-items justify-content-between'>
                        <Button primary className="borderRadius marginRight whiteSpace" fluid size='small' onClick={props.onClickTimeCardReview}>
                            Timecard Review  </Button>
                        {props.timeCard.isIssueNoteVisible &&
                            <Button primary className="borderRadius marginRight whiteSpace" fluid size='small' onClick={props.getTimeCardIssue}>
                                Issues <span className="issueNumber">{props.timeCard.issueNotesCount}</span> </Button>
                        }
                        <Button primary className="borderRadius marginRight whiteSpace" fluid size='small' onClick={() => { props.onClickDailyDetails() }}>
                            Daily Details <span className="issueNumber">{props.timeCard.dailyDetailsCount}</span> </Button>
                        <Button style={{ opacity: props.timeCard.tmTaskCodeList.length > 0 ? "1" : "0.8" }} primary className="borderRadius marginRight whiteSpace" fluid size='small' onClick={() => props.timeCard.tmTaskCodeList.length > 0 && props.onClickTMVoucherBtn()}>
                            {Constants.TM_VOUCHER_BUTTON_TEXT} <span className="tmVoucherNumber">{props.timeCard.tmVouchersCount}</span>
                        </Button>
                        <Button primary className="borderRadius marginRight whiteSpace" fluid size='small' onClick={props.onClickGrpByModel}>
                            Group By </Button>
                        <Button primary size='small' circular icon='plus' onClick={() => { props.onClickAddTimeCard() }} />
                    </div>
                </Header>
            </Segment>
            <Segment className="overflowScroll tableScrollData pb-5 ">
                <Table unstackable className={props.timeCard.defaultGroupBy === Constants.PROJECT ? 'projectTime' : 'employeeTime'}>
                    <Table.Header className="tableHeaderScroll">
                        <Table.Row textAlign="center">
                            <Table.HeaderCell rowSpan='2'> </Table.HeaderCell >
                            <Table.HeaderCell rowSpan='2'>Edit </Table.HeaderCell >
                            <Table.HeaderCell rowSpan='2' className="whiteSpace">Punches</Table.HeaderCell>
                            {props.timeCard.defaultGroupBy === Constants.EMPLOYEE &&
                                <Table.HeaderCell rowSpan='2' className="whiteSpace">Attestation</Table.HeaderCell>
                            }
                            <Table.HeaderCell rowSpan='2'>Payroll Note </Table.HeaderCell>
                            <Table.HeaderCell rowSpan='2'>Employee </Table.HeaderCell>
                            <Table.HeaderCell rowSpan='2'>Project </Table.HeaderCell>
                            <Table.HeaderCell rowSpan='2' className="whiteSpace">Task Code </Table.HeaderCell>
                            <Table.HeaderCell rowSpan='2'>Shift </Table.HeaderCell>
                            <Table.HeaderCell className="hoursPadding" colSpan='3'>Hours</Table.HeaderCell>
                            <Table.HeaderCell rowSpan='2'>Actuals </Table.HeaderCell>
                            <Table.HeaderCell rowSpan='2'>Expectations </Table.HeaderCell>
                            <Table.HeaderCell rowSpan='2'>Status </Table.HeaderCell>
                            <Table.HeaderCell rowSpan='2' className="whiteSpace">Status Code </Table.HeaderCell>
                            <Table.HeaderCell rowSpan='2' className="whiteSpace">Job Override </Table.HeaderCell>
                            <Table.HeaderCell rowSpan='2' className="whiteSpace">Union Override </Table.HeaderCell>
                            <Table.HeaderCell rowSpan='2' className="whiteSpace">Work done <br />at Job Site </Table.HeaderCell>
                            <Table.HeaderCell rowSpan='2'>Delete </Table.HeaderCell>
                        </Table.Row>
                        <Table.Row textAlign="center">
                            {/* <Table.HeaderCell colSpan='7' ></Table.HeaderCell> */}
                            <Table.HeaderCell>ST</Table.HeaderCell>
                            <Table.HeaderCell>OT</Table.HeaderCell>
                            <Table.HeaderCell>DT</Table.HeaderCell>
                            {/* <Table.HeaderCell colSpan='7' ></Table.HeaderCell> */}
                        </Table.Row>
                    </Table.Header>
                    {props.timeCard.timeRecords && props.timeCard.timeRecords.length > 0 && props.timeCard.timeRecords.map((rowData, rowIndex) => {
                        let showGroupValidationErrors = false;
                        const validationTimeRecordIdsWithTypes = props.timeCard.validationTimeRecordIdsWithTypes;
                        const timeRecordIds = rowData.timecardData.map((a) => a.timeRecordID);
                        const checkIdsInValidationIds = (checkingIds) => checkingIds?.length > 0 && (checkingIds.some((id) => timeRecordIds.includes(id)) || timeRecordIds.some((id) => checkingIds.includes(id)));

                        if (validationTimeRecordIdsWithTypes?.length > 0 && props.timeCard.defaultGroupBy === Constants.EMPLOYEE) {
                            const punchesIds = validationTimeRecordIdsWithTypes.find((val) => val.type === Constants.PUNCHES);
                            const notAttestIds = validationTimeRecordIdsWithTypes.find((val) => val.type === Constants.NOTATTEST);
                            if (props.timeCard.isAllowAttestation && ((punchesIds && checkIdsInValidationIds(punchesIds.id)) || (notAttestIds && checkIdsInValidationIds(notAttestIds.id)))) {
                                showGroupValidationErrors = true;
                            }
                        }

                        return (
                            <Table.Body key={`${rowIndex}`}>
                                {props.timeCard.defaultGroupBy === Constants.PROJECT && rowData.projectNumber &&
                                    <Table.Row style={{ backgroundColor: 'white' }}>
                                        <Table.Cell colSpan='3'><b>{`Project - ${rowData.projectNumber}`}</b></Table.Cell>
                                        <Table.Cell colSpan='11'></Table.Cell>
                                    </Table.Row>
                                }
                                {
                                    rowData.timecardData.map((data, index) => {
                                        count++;
                                        let errorClassname = "";
                                        if (data.showTimeCardError && index === 0) {
                                            errorClassname = "groupDuplicateTop";
                                        }
                                        if (data.showTimeCardError && index === rowData.timecardData.length - 1) {
                                            errorClassname = errorClassname + " " + "groupDuplicateBottom";
                                        }
                                        return (
                                            <Table.Row key={`${rowIndex}${index}`} className={` ${(count % 2 === 0) ? 'projectIndexEven' : 'projectIndexOdd'} ${(data.showTimeCardError && !showGroupValidationErrors) ? 'rowDuplicate' : showGroupValidationErrors ? errorClassname : 'rowOriginal'} ${showGroupValidationErrors ? "groupDuplicateLeft groupDuplicateRight" : ""}`}>
                                                < Table.Cell >
                                                    <Checkbox className='selectedTable' checked={!data.attestationStatus && data.checked} onChange={(e, value) => props.onSelectedTimeCard(e, { value, rowIndex: rowIndex, cellIndex: index, isAttested: data.attestationStatus })} />
                                                </Table.Cell>
                                                {
                                                    <Table.Cell>{props.timeCard.defaultGroupBy == Constants.EMPLOYEE && index === 0 ? <div className="d-flex justify-content-center" onClick={() => {
                                                        props.onClickEdit({ isEditTimeCard: true, timeCardId: data.timeRecordID, projectID: data.projectID, employeeID: data.employeeID, deviceId: data.deviceID, index: rowIndex });
                                                    }}><span className="iconify editFileIcon" data-icon="clarity:edit-line"></span>
                                                    </div> : props.timeCard.defaultGroupBy == Constants.PROJECT ? <div className="d-flex justify-content-center" onClick={() => {
                                                        props.onClickEdit({ isEditTimeCard: true, timeCardId: data.timeRecordID, projectID: data.projectID, employeeID: data.employeeID, deviceId: data.deviceID, index: rowIndex, shift: data.shift, taskId: data.taskCodeID });
                                                    }}><span className="iconify editFileIcon" data-icon="clarity:edit-line"></span>
                                                    </div> : ''}</Table.Cell>
                                                }
                                                <Table.Cell>{props.timeCard.defaultGroupBy === Constants.EMPLOYEE && index === 0 ?
                                                    <div className="startLunchTimeWraping" onClick={() => props.onClickStartAndLunchTime(rowData, data.attestationStatus)}>
                                                        <span>{data.startTime}</span>
                                                        <span>{data.lunchStartTime}</span>
                                                        <span>{data.lunchEndTime}</span>
                                                        <span>{data.endTime}</span>
                                                    </div>
                                                    : props.timeCard.defaultGroupBy == Constants.PROJECT ?
                                                        <div className="startLunchTimeWraping" onClick={() => props.onClickStartAndLunchTime(data, data.attestationStatus)}>
                                                            <span>{data.startTime}</span>
                                                            <span>{data.lunchStartTime}</span>
                                                            <span>{data.lunchEndTime}</span>
                                                            <span>{data.endTime}</span>
                                                        </div>
                                                        : ''}
                                                </Table.Cell>

                                                {props.timeCard.defaultGroupBy == Constants.EMPLOYEE && (index === 0 ?
                                                    <RenderAttestation isAllowAttestation={props.timeCard.isAllowAttestation} openAttestationModal={() => props.openAttestation(data.employeeID)} attestationStatus={data.attestationStatus} timeCardStatus={data.intStatus} isFromTimeCard={true} />
                                                    :
                                                    <Table.Cell></Table.Cell>)
                                                }
                                                <Table.Cell>
                                                    {
                                                        (props.timeCard.defaultGroupBy == Constants.EMPLOYEE && index === 0) ?
                                                            <div className="d-flex justify-content-center" >
                                                                <div className={data.payrollNote != null ? "fileEditOutlineHighlighted" : "fileEditOutline"} onClick={() => {
                                                                    props.onClickEdit({ modalOpenPayRollNote: true, timeCardId: data.timeRecordID, deviceId: data.deviceID, index: rowIndex, employeeName: rowData.employeeName });
                                                                }}>
                                                                    <span className="iconify fSize-22" data-icon="mdi-file-edit-outline" data-inline="false" ></span>
                                                                </div>
                                                            </div>
                                                            : props.timeCard.defaultGroupBy === Constants.PROJECT ?
                                                                <div className="d-flex justify-content-center" >
                                                                    <div className={data.payrollNote != null ? "fileEditOutlineHighlighted" : "fileEditOutline"} onClick={() => {
                                                                        props.onClickEdit({ modalOpenPayRollNote: true, timeCardId: data.timeRecordID, deviceId: data.deviceID, index: rowIndex });
                                                                    }} >
                                                                        <span className="iconify fSize-22" data-icon="mdi-file-edit-outline" data-inline="false" ></span>
                                                                    </div>
                                                                </div>
                                                                : ''
                                                    }
                                                </Table.Cell>
                                                <Table.Cell className='whiteSpace text-left'><b>{props.timeCard.defaultGroupBy === Constants.EMPLOYEE && index === 0 ? `${rowData.employeeName} (${data.employeeNumber})` : props.timeCard.defaultGroupBy === Constants.PROJECT ? `${data.fullName} (${data.employeeNumber})` : ''}</b></Table.Cell>
                                                <Table.Cell>{data.projectNumber}</Table.Cell>
                                                <Table.Cell>{data.taskNumber}</Table.Cell>
                                                <Table.Cell>{data.shift}</Table.Cell>
                                                <Table.Cell>{data.stHours ? data.stHours : 0}</Table.Cell>
                                                <Table.Cell>{data.otHours ? data.otHours : 0}</Table.Cell>
                                                <Table.Cell>{data.dtHours ? data.dtHours : 0}</Table.Cell>
                                                <Table.Cell>
                                                    {<div className="d-flex justify-content-center" >
                                                        <div className={data.workNote !== null || data.workUnits !== null || data.isAttachmentAdded ? "fileEditOutlineHighlighted" : "fileEditOutline"} onClick={() => {
                                                            props.onClickEdit({ modalOpenActualNote: true, timeCardId: data.timeRecordID, deviceId: data.deviceID, index: rowIndex });
                                                        }} >
                                                            <span className="iconify fSize-22" data-icon="mdi-file-edit-outline" data-inline="false" ></span>
                                                        </div>
                                                    </div>
                                                    }
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {
                                                        <div className="d-flex justify-content-center" >
                                                            <div className={data.expectationNote !== null || data.expectationUnits > 0 ? "fileEditOutlineHighlighted" : "fileEditOutline"} onClick={() => {
                                                                props.onClickEdit({ modalOpenExceptationalNote: true, timeCardId: data.timeRecordID, deviceId: data.deviceID, index: rowIndex });
                                                            }} >
                                                                <span className="iconify fSize-22" data-icon="mdi-file-edit-outline" data-inline="false" ></span>
                                                            </div>
                                                        </div>
                                                    }
                                                </Table.Cell>
                                                <Table.Cell className="text-center">
                                                    {TimeCardStatus(data.intStatus)}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    <Dropdown className="statusCodeDropdown"
                                                        fluid
                                                        selection
                                                        placeholder={"-Select-"}
                                                        options={props.timeCard.statusCodeDataList}
                                                        value={data.fieldStatusId}
                                                        key={data.fieldStatusId}
                                                        onChange={(e, { value }) => props.onChangeStatusCode(value, data.timeRecordID, rowIndex)}
                                                        selectOnBlur={false}
                                                        selectOnNavigation={false}
                                                    />
                                                </Table.Cell>
                                                <Table.Cell>{data.jobOverride}</Table.Cell>
                                                <Table.Cell>{data.unionOverride}</Table.Cell>
                                                <Table.Cell>
                                                    <Checkbox className='selectedTable'
                                                        name="checkbox"
                                                        checked={(data.workDoneAtJobSite == 'true' || data.workDoneAtJobSite == 'Yes')}
                                                        onChange={(e, value) => props.onChangeWorkDoneAtJobSite(e, { value, rowIndex: rowIndex, cellIndex: index })}
                                                    />
                                                </Table.Cell>
                                                <Table.Cell>
                                                    <Icon color="red" name="trash" className="trashIcon" onClick={() => { props.onClickDeleteIcon({ projectId: data.projectID, employeeId: data.employeeID, rowIndex: rowIndex, cellIndex: index, isAttested: data.attestationStatus }); }} ></Icon>
                                                </Table.Cell>
                                            </Table.Row>
                                        )
                                    })
                                }
                                {props.timeCard.defaultGroupBy === Constants.PROJECT ?
                                    // <Table.Row className={(count % 2 === 0) ? 'projectIndexEven' : 'projectIndexOdd'} >
                                    <Table.Row className="totalHoursRows">
                                        <Table.Cell colSpan='7'></Table.Cell>
                                        <Table.Cell>Total</Table.Cell>
                                        <Table.Cell>{utility.getFormatedTotalHours(rowData.totalStHours)}</Table.Cell>
                                        <Table.Cell>{utility.getFormatedTotalHours(rowData.totalOtHours)}</Table.Cell>
                                        <Table.Cell>{utility.getFormatedTotalHours(rowData.totalDtHours)}</Table.Cell>
                                        <Table.Cell colSpan='8'></Table.Cell>
                                    </Table.Row>
                                    :
                                    <Table.Row className="totalHoursRows">
                                        <Table.Cell colSpan='8'></Table.Cell>
                                        <Table.Cell>Total</Table.Cell>
                                        <Table.Cell>{utility.getFormatedTotalHours(rowData.totalStHours)}</Table.Cell>
                                        <Table.Cell>{utility.getFormatedTotalHours(rowData.totalOtHours)}</Table.Cell>
                                        <Table.Cell>{utility.getFormatedTotalHours(rowData.totalDtHours)}</Table.Cell>
                                        <Table.Cell colSpan='8'></Table.Cell>
                                    </Table.Row>
                                }
                            </Table.Body>
                        )
                    })}
                </Table>

            </Segment >
            <Segment className="footerButtons">
                <div className='d-flex align-items justify-content-evenly btnFooter'>
                    <Button secondary className="borderRadius w-10" size='small' onClick={() => { props.onClickLogout() }}>
                        Logout  </Button>
                </div>
            </Segment>
            {
                props.timeCard.selectedTimeRecordsForDelete.length > 0 &&
                <Segment className="footerButtons">
                    <div className='d-flex align-items justify-content-between btnFooter'>
                        <Button secondary className="borderRadius w-10" size='small' onClick={() => { props.onCancelCheckBox() }}>
                            Cancel  </Button>
                        <Button secondary className="borderRadius w-10" size='small' onClick={() => { props.onClickDeleteButton() }}>
                            Delete  </Button>
                    </div>
                </Segment>
            }

            {/* Payroll Notes Popup */}
            <Modal
                open={props.timeCard.isOpenPayRollNotes}
                closeOnDimmerClick={false}
                size='tiny'
            >
                <Modal.Header className="text-center">Payroll Note</Modal.Header>
                <Modal.Actions className="d-flex justify-content-between">
                    <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={props.onClickPayRollNoteBack}>
                        Back
                    </Button>
                    <Button secondary className="borderRadius w-25 mr-0" size='small' onClick={() => props.savePayRollNote({ modalOpenPayRollNote: false, timeCardId: props.timeCard.selectedPayRollNote ? props.timeCard.selectedPayRollNote.timeRecordID : "", deviceId: props.timeCard.selectedPayRollNote ? props.timeCard.selectedPayRollNote.deviceID : "", employeeName: props.timeCard.selectedPayRollNote ? props.timeCard.selectedPayRollNote.employeeName : "" })}>
                        Save
                    </Button>
                </Modal.Actions>
                <Modal.Content className="overflowVisible hideDefaultText" scrolling style={{ minHeight: "auto" }}>
                    <Form>
                        <Dropdown
                            placeholder=" "
                            name="payRollNote"
                            fluid
                            selection
                            options={props.timeCard.payRollNoteListOptions}
                            onChange={props.handlePayRollNoteChange}
                            value={props.timeCard.selectedPayRollNote.payRollNotesDropDownValue ? props.timeCard.selectedPayRollNote.payRollNotesDropDownValue : ''}
                            selectOnBlur={false}
                        />
                        {props.timeCard.selectedPayRollNote.payRollNotesDropDownValue === 'Other' &&
                            <TextArea rows="2" className="textAreaInput maxHeightTextArea minHeightTextArea mt-2"
                                value={props.timeCard.selectedPayRollNote.payRollNoteOtherText ? props.timeCard.selectedPayRollNote.payRollNoteOtherText : ''}
                                onChange={props.handlePayRollNoteTextChange}
                                placeholder='Notes'
                                maxLength="50"
                            />
                        }
                    </Form>
                </Modal.Content>

                {props.timeCard.isShowLoader &&
                    <Loader />
                }
            </Modal>
            {/* Actual Work Note Popup */}
            <Modal
                open={props.timeCard.isOpenActualNotes}
                closeOnDimmerClick={false}
                size='tiny'
            >
                <Modal.Header className="text-center">Actuals</Modal.Header>
                <Modal.Content scrolling style={{ minHeight: "auto" }}>
                    <Form>
                        <Form.Group className='mb-2'>
                            <Form.Input className='modalInput unitInput' label='Actual Units' maxLength="5" placeholder='Actual Units' width={6} value={props.timeCard.selectedActualNote.actualUnits} onChange={props.handleActualUnitChange} />
                            <Form.Input className='modalInput' control={TextArea} rows="1" maxLength="1000" label='Actual Work Notes' placeholder='Actual Notes' width={10} value={props.timeCard.selectedActualNote.actualNote} onChange={props.handleActualNoteChange} />
                        </Form.Group>
                        <Form.Group widths='equal'>
                            <Form.Field className='d-flex'>
                                <label>Attachments</label>
                                <div className='d-flex justify-content-between w-100 ml-3'>
                                    <ImageUploading
                                        multiple
                                        value={props.timeCard.selectedActualNote.attachments}
                                        onChange={props.onChangeActulNoteAttachment}
                                        acceptType={['jpg', 'png']}
                                    >{({
                                        onImageUpload,
                                        isDragging,
                                        dragProps,
                                    }) => (
                                        <div className="upload__image-wrapper">
                                            <Button type="button" secondary className="borderRadius w-65" size='small' style={isDragging ? { color: 'red' } : undefined} onClick={onImageUpload}
                                                {...dragProps}>
                                                Select files...  </Button>
                                            <div className="attachmentImage">
                                                {props.timeCard.selectedActualNote.attachments.map((image, index) => (
                                                    image.IsActive ?
                                                        <div key={index} >
                                                            <img src={Constants.DATA_BASE64 + image.AttachmentContent} className='modalSubImage' alt="" onClick={() => props.openAttachmentViewer(image)} />
                                                            <div className="image-item__btn-wrapper attachmentPointer">
                                                                <Icon name="close icon" onClick={() => props.onActualNoteAttachmentRemove(index)}></Icon>
                                                            </div>
                                                        </div> : ''
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                    </ImageUploading>
                                </div>
                            </Form.Field>
                        </Form.Group>
                        {/* <div className='attachmentImage'>
                            <Image className='modalSubImage' src='' />
                        </div> */}
                    </Form>
                </Modal.Content>
                <Modal.Actions className="d-flex justify-content-between">
                    <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={props.onClickActualNoteBack}>
                        Back
                    </Button>
                    <Button secondary className="borderRadius w-25 mr-0" size='small' disabled={props.timeCard.isActualNoteSaveBtnDisabled} onClick={() => props.saveActualNote({ modalOpenActualNote: false, timeCardId: props.timeCard.selectedActualNote ? props.timeCard.selectedActualNote.timeRecordID : "", deviceId: props.timeCard.selectedActualNote ? props.timeCard.selectedActualNote.deviceID : "" })}>
                        Save
                    </Button>
                </Modal.Actions>
                {props.timeCard.isShowLoader &&
                    <Loader />
                }
            </Modal>
            {/* Expectations Note Popup */}
            <Modal
                open={props.timeCard.isOpenExceptationalNotes}
                closeOnDimmerClick={false}
                size='tiny'>
                <Modal.Header className="text-center">Expectations</Modal.Header>
                <Modal.Content scrolling style={{ minHeight: "auto" }}>
                    <Form>
                        <Form.Group className='mb-2'>
                            <Form.Input className='modalInput unitInput' label='Units' maxLength="5" placeholder='Units' width={6} value={props.timeCard.selectedExpectationsNote.expectationUnits} onChange={props.handleExpectationUnitChange} />
                            <Form.Input className='modalInput' maxLength="1000" control={TextArea} rows="1" label='Notes' placeholder='Notes' width={10} value={props.timeCard.selectedExpectationsNote.expectationNote} onChange={props.handleExpectationNoteChange} />
                        </Form.Group>
                    </Form>
                </Modal.Content>
                <Modal.Actions className="d-flex justify-content-between">
                    <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={props.onClickExpectationNoteBack}>
                        Back
                    </Button>
                    <Button secondary className="borderRadius w-25 mr-0" size='small' onClick={() => props.saveExpectationNote({ modalOpenExceptationalNote: false, timeCardId: props.timeCard.selectedExpectationsNote ? props.timeCard.selectedExpectationsNote.timeRecordID : "", deviceId: props.timeCard.selectedExpectationsNote ? props.timeCard.selectedExpectationsNote.deviceID : "" })}>
                        Save
                    </Button>
                </Modal.Actions>
                {props.timeCard.isShowLoader &&
                    <Loader />
                }
            </Modal>
            {/* Issue Note Popup */}
            <Modal open={props.timeCard.isIssueNoteModalVisible}
                closeOnDimmerClick={false}
                size='tiny'>
                <Modal.Header className="text-center">Issue Notes <Button className='float-right' compact positive icon='plus' size='small' onClick={props.onClickAddIssueNote} /></Modal.Header>
                <Modal.Content scrolling style={{ minHeight: "auto" }}>
                    <Form className="d-flex flexDirectionColumnReverse">
                        {props.timeCard.selectedIssueNotes && props.timeCard.selectedIssueNotes.filter(a => !a.isDeleted).length > 0 ? props.timeCard.selectedIssueNotes.map((project, index) => (
                            !project.isDeleted &&
                            (<div>
                                {project.status == Constants.IN_PROGRESS &&
                                    <Form.Group inline className="justify-content-end">
                                        <Button type="button" compact negative icon='trash' size='small' onClick={() => props.onRemoveIssueNotes(index)} />
                                    </Form.Group>
                                }
                                <Form.Group inline className="hideDefaultText">
                                    <label className="textTransformLower">Project</label>
                                    {(project.status === Constants.NEW_STATUS) ?
                                        <Input style={{ width: '80%' }} placeholder='Project' value={project.projectNumber} disabled={true} />
                                        :
                                        <Dropdown style={{ width: '80%' }}
                                            name="project"
                                            fluid
                                            selection
                                            placeholder=" "
                                            options={props.timeCard.projectList}
                                            disabled={(project.status == Constants.IN_PROGRESS || project.status == Constants.ACTIVE) ? false : true}
                                            onChange={(e, { name, value }) => props.onChangeIssueNotesProjectDropDown(index, value, 'project')}
                                            value={project.projectId > 0 ? project.projectId : ''}
                                            selectOnBlur={false}
                                        />
                                    }
                                </Form.Group>
                                <Form.Group inline>
                                    <label className='textTransformLower'>Notes</label>
                                    <TextArea className="minHeightTextArea" maxLength="250" style={{ width: '80%' }} fluid selection rows='2' value={project.issueNote} disabled={(project.status == Constants.IN_PROGRESS || project.status == Constants.ACTIVE) ? false : true} onChange={(e) => props.onChangeIssueNotesProjectDropDown(index, e, 'notes')} />
                                </Form.Group>
                                <Form.Group inline style={{ position: 'relative', marginTop: '2rem', alignItems: 'stretch' }} className="hideDefaultText">
                                    <label className='textTransformLower' style={{
                                        alignItems: 'center',
                                        display: 'inline-flex'
                                    }}>Status Code</label>
                                    {(project.status === Constants.IN_PROGRESS || project.status === Constants.ACTIVE) ?
                                        <Dropdown
                                            className="dropdownTimecardStatus"
                                            name="statusCode"
                                            fluid
                                            selection
                                            placeholder="-Select-"
                                            options={props.timeCard.statusCodeDataList}
                                            disabled={(project.status == Constants.IN_PROGRESS || project.status == Constants.ACTIVE) ? false : true}
                                            onChange={(e, { name, value }) => props.onChangeIssueNotesProjectDropDown(index, value, 'statusCode')}
                                            value={project.fieldStatusId > 0 ? project.fieldStatusId : ''}
                                            selectOnBlur={false}
                                        /> :
                                        <TextArea className="disableTextArea" fluid value={project.fieldStatusId ? `${project.fieldStatusInitial}-${project.fieldStatusDescription}` : ""} disabled={true} />
                                    }
                                    <label className='textTransformLower_1'>Lost Hours</label>
                                    <Input
                                        //placeholder='1'
                                        maxLength='5'
                                        value={project.lostHours ?? ""}
                                        style={{ width: '25%', marginLeft: '1rem' }}
                                        disabled={(project.status == Constants.IN_PROGRESS || project.status == Constants.ACTIVE) ? false : true}
                                        onChange={(e) => props.onChangeIssueNotesProjectDropDown(index, e, 'lostHours')}
                                    />
                                </Form.Group>
                                <Form.Group widths='equal'>
                                    <Form.Field className='d-flex'>
                                        <label className="attachIssue">Attachments</label>
                                        <div className='d-flex justify-content-between w-100 ml-3'>
                                            <ImageUploading
                                                multiple
                                                value={project.attachment}
                                                onChange={(images) => { props.onChangeIssueNoteAttachment(images, index, project?.attachment ?? []) }}
                                                acceptType={['jpg', 'png']}
                                            >{({
                                                onImageUpload,
                                                isDragging,
                                                dragProps,
                                            }) => (
                                                <div className="upload__image-wrapper">
                                                    {(project.status === Constants.IN_PROGRESS || project.status === Constants.ACTIVE) &&
                                                        <Button type="button" secondary className="borderRadius w-65" fluid size='small' style={isDragging ? { color: 'red' } : undefined} onClick={onImageUpload} disabled={(project.status == Constants.IN_PROGRESS || project.status == Constants.ACTIVE) ? false : true}
                                                            {...dragProps}>
                                                            Select files...  </Button>
                                                    }
                                                    <div className="attachmentImage">
                                                        {project.attachment.map((image, imageIndex) => (
                                                            image.IsActive ?
                                                                <div key={imageIndex}>
                                                                    <img src={Constants.DATA_BASE64 + image.AttachmentContent} className={(project.status == Constants.IN_PROGRESS || project.status == Constants.ACTIVE) ? 'modalSubImage' : 'modalSubImage modalSubImage_margin'} alt="" onClick={() => props.openAttachmentViewer(image)} />
                                                                    {((project.status == Constants.IN_PROGRESS || project.status == Constants.ACTIVE) && image.IsActive) &&
                                                                        <div className="image-item__btn-wrapper attachmentPointer">
                                                                            <Icon name="close icon" onClick={() => props.removeIssueNotesAttachment(index, imageIndex)}></Icon>
                                                                        </div>
                                                                    }
                                                                </div> : ''
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                            </ImageUploading>
                                        </div>
                                    </Form.Field>
                                </Form.Group>
                            </div>)
                        )) : <NoResultFound displayMessage={Constants.NO_ISSUE_NOTES_FOUND} />
                        }
                    </Form>
                </Modal.Content>
                <Modal.Actions className="d-flex justify-content-between">
                    <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={props.onClickIssueNotesBack}>
                        Back
                    </Button>
                    <Button disabled={props.timeCard.isSaveIssueNoteButtonDisabled} secondary className="borderRadius w-25 mr-0" size='small' onClick={props.onSaveIssueNotesModel} >
                        Save
                    </Button>
                </Modal.Actions>
                {props.timeCard.isShowLoader &&
                    <Loader />
                }
            </Modal>

            {
                props.timeCard.isAttachmentModelVisible &&
                <AttachmentViewer attachmentName={props.timeCard.selectedAttachment.AttachmentName} attachmentContent={props.timeCard.selectedAttachment.AttachmentContent} closeAttachmentViewer={props.closeAttachmentViewer} />
            }

            {/* TimeCard Review Popup */}
            <Modal
                open={props.timeCard.isOpenTimeCardReview}
                closeOnDimmerClick={false}
                size='tiny'
            >
                <Modal.Header className="text-center">Timecard Review</Modal.Header>
                <Modal.Content className="text-center" scrolling style={{ minHeight: "auto" }}>
                    <Button primary className="borderRadius  whiteSpace w-65" size='small' onClick={props.onClickCurrentWeekTimeCard}>
                        View Current Week Timecard
                    </Button>
                    <Button primary className="borderRadius  whiteSpace mt-2 w-65" size='small' onClick={props.onClickPreviousWeekTimeCard}>
                        View Previous Week Timecard
                    </Button>
                </Modal.Content>
                <Modal.Actions>
                    <Button secondary className="borderRadius w-25 mr-0" size='small' onClick={props.onCloseTimeCardReview}>
                        Back
                    </Button>
                </Modal.Actions>
                {props.timeCard.isShowLoader &&
                    <Loader />
                }
            </Modal>
            {/* Group By Popup */}
            <Modal
                open={props.timeCard.isGroupByModelVisible}
                closeOnDimmerClick={false}
                size='tiny'
            >
                <Modal.Header className="text-center">Group By</Modal.Header>
                <Modal.Content className="text-center" scrolling style={{ minHeight: "auto" }}>
                    <Button primary className="borderRadius  whiteSpace w-50" size='small' onClick={() => props.onChangeGroupByOption(Constants.PROJECT)}>
                        Project
                    </Button>
                    <Button primary className="borderRadius  whiteSpace mt-2 w-50" size='small' onClick={() => props.onChangeGroupByOption(Constants.EMPLOYEE)}>
                        Employee
                    </Button>
                </Modal.Content>
                <Modal.Actions>
                    <Button secondary className="borderRadius w-25 mr-0" size='small' onClick={props.onCloseGrpByModel}>
                        Back
                    </Button>
                </Modal.Actions>
                {props.timeCard.isShowLoader &&
                    <Loader />
                }
            </Modal>

            {/* PayRollNoteSaveConfimation popup */}
            <Modal
                open={props.timeCard.isShowPayRollNoteSaveConfimation}
                closeOnDimmerClick={false}
                size='tiny'
            >
                <Modal.Header className="text-center">Confirmation</Modal.Header>
                <Modal.Content >
                    Do you want to save changes?
                </Modal.Content>
                <Modal.Actions className="d-flex justify-content-between">
                    <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={props.onClosePayRollModel}>
                        No
                    </Button>
                    <Button secondary className="borderRadius w-25 mr-0" size='small' onClick={() => props.savePayRollNote({ modalOpenPayRollNote: false, timeCardId: props.timeCard.selectedPayRollNote ? props.timeCard.selectedPayRollNote.timeRecordID : "", deviceId: props.timeCard.selectedPayRollNote ? props.timeCard.selectedPayRollNote.deviceID : "", employeeName: props.timeCard.selectedPayRollNote ? props.timeCard.selectedPayRollNote.employeeName : "" })}>
                        Yes
                    </Button>
                </Modal.Actions>
                {props.timeCard.isShowLoader &&
                    <Loader />
                }
            </Modal>

            {/* IssueNoteSaveConfimation popup */}
            <Modal
                open={props.timeCard.isShowIssueNoteSaveConfirmation}
                closeOnDimmerClick={false}
                size='tiny'
                style={{
                    position: 'absolute',
                    inset: 0,
                    height: 'fit-content',
                    margin: 'auto'
                }}
            >
                <Modal.Header className="text-center">Confirmation</Modal.Header>
                <Modal.Content >
                    Do you want to save changes?
                </Modal.Content>
                <Modal.Actions className="d-flex justify-content-between">
                    <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={props.closeIssueNotes}>
                        No
                    </Button>
                    <Button secondary className="borderRadius w-25 mr-0" size='small' onClick={props.onSaveIssueNotesModel}>
                        Yes
                    </Button>
                </Modal.Actions>
                {props.timeCard.isShowLoader &&
                    <Loader />
                }
            </Modal>

            {/* ExpectationNoteSaveConfimation popup */}
            <Modal
                open={props.timeCard.isShowExpectationNoteSaveConfimation}
                closeOnDimmerClick={false}
                size='tiny'
            >
                <Modal.Header className="text-center">Confirmation</Modal.Header>
                <Modal.Content >
                    Do you want to save changes?
                </Modal.Content>
                <Modal.Actions className="d-flex justify-content-between">
                    <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={props.onCloseExpectationNoteModel}>
                        No
                    </Button>
                    <Button secondary className="borderRadius w-25 mr-0" size='small' onClick={() => props.saveExpectationNote({ modalOpenExceptationalNote: false, timeCardId: props.timeCard.selectedExpectationsNote ? props.timeCard.selectedExpectationsNote.timeRecordID : "", deviceId: props.timeCard.selectedExpectationsNote ? props.timeCard.selectedExpectationsNote.deviceID : "" })}>
                        Yes
                    </Button>
                </Modal.Actions>
                {props.timeCard.isShowLoader &&
                    <Loader />
                }
            </Modal>

            {/* ActualNoteSaveConfirmation popup */}
            <Modal
                open={props.timeCard.isShowActualNoteSaveConfirmation}
                closeOnDimmerClick={false}
                size='tiny'
            >
                <Modal.Header className="text-center">Confirmation</Modal.Header>
                <Modal.Content >
                    Do you want to save changes?
                </Modal.Content>
                <Modal.Actions className="d-flex justify-content-between">
                    <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={props.onCloseActualNoteModel}>
                        No
                    </Button>
                    <Button secondary className="borderRadius w-25 mr-0" size='small' onClick={() => props.saveActualNote({ modalOpenActualNote: false, timeCardId: props.timeCard.selectedActualNote ? props.timeCard.selectedActualNote.timeRecordID : "", deviceId: props.timeCard.selectedActualNote ? props.timeCard.selectedActualNote.deviceID : "" })}>
                        Yes
                    </Button>
                </Modal.Actions>
                {props.timeCard.isShowLoader &&
                    <Loader />
                }
            </Modal>

            {/* Delete Timecard Popup */}
            {
                props.timeCard.isDeleteConfirmationPopupVisible &&
                <Modal closeIcon
                    open={props.timeCard.isDeleteConfirmationPopupVisible}
                    closeOnDimmerClick={false}
                    size='tiny'
                    onClose={props.onCancelDeletePopup}
                >
                    <Modal.Header className="headerColor text-color text-center">Delete Timecard</Modal.Header>
                    <Modal.Content scrolling style={{ minHeight: "auto" }}>
                        <p>Are you sure? Do you want to delete selected timecard?</p>
                    </Modal.Content>
                    <Modal.Actions className="d-flex justify-content-between">
                        <Button secondary onClick={props.onCancelDeletePopup} className="borderRadius w-25 ml-0" size='small' >
                            Cancel
                        </Button>
                        <Button secondary onClick={props.deleteTimeCard} className="borderRadius w-25 mr-0" size='small' >
                            Delete
                        </Button>
                    </Modal.Actions>
                    {props.timeCard.isShowLoader &&
                        <Loader />
                    }
                </Modal>
            }
            {/* TimeCard Submitted Popup */}
            <Modal
                open={props.timeCard.isSubmitModelVisible}
                closeOnDimmerClick={false}
                size='tiny'
            ><Modal.Content scrolling className="text-center" style={{ minHeight: "auto" }}>
                    <p>{props.timeCard.timeCardSubmittedMessage}</p>
                </Modal.Content>
                <Modal.Actions className="d-flex justify-content-around">
                    <Button secondary className="borderRadius ml-0" size='small' onClick={props.onClickSubmittedTimeCardPage}>
                        View Submitted Timecards</Button>
                    <Button secondary className="borderRadius ml-0" size='small' onClick={props.closeSubmitModel}>
                        {(props.timeCard.isTMVoucherSubmitted ? Constants.CL_RE_TM_TAGS : "Close")}
                    </Button>
                </Modal.Actions>
                {props.timeCard.isShowLoader &&
                    <Loader />
                }
            </Modal>
            {/* Issue Note Submitted Popup */}
            <Modal
                open={props.timeCard.isSubmitIssueNoteModelVisible}
                closeOnDimmerClick={false}
                size='tiny'
            ><Modal.Content scrolling className="text-center" style={{ minHeight: "auto" }}>
                    <p>{props.timeCard.issueNoteSubmittedMessage}</p>
                </Modal.Content>
                <Modal.Actions className="d-flex justify-content-around">
                    <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={props.closeIssueNotesSubmitModel}>
                        Close
                    </Button>
                </Modal.Actions>
                {props.timeCard.isShowLoader &&
                    <Loader />
                }
            </Modal>
            {/*Submit Confirmation popup */}
            <Modal
                open={props.timeCard.isSubmitConfirmationModelVisible}
                closeOnDimmerClick={false}
                size='tiny'
            >
                <Modal.Header className="text-center">Confirmation</Modal.Header>
                <Modal.Content >
                    {props.timeCard.isSubmitConfirmationMessage}
                </Modal.Content>
                <Modal.Actions className="d-flex justify-content-between">
                    <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={props.closeSubmitConfirmationModal}>
                        No
                    </Button>
                    <Button secondary className="borderRadius w-25 mr-0" size='small' onClick={props.onClickSync}>
                        Yes
                    </Button>
                </Modal.Actions>
                {props.timeCard.isShowLoader &&
                    <Loader />
                }
            </Modal>

            {/* Select Task Code Popup */}
            {!props.timeCard.isShowLoader && props.timeCard.isShowTMVoucher &&
                <SelectTMVoucherModal
                    tmVoucherHeaderTwo={Constants.TM_VOUCHER_POPUP_HEADING_FILL_DATA}
                    isShowTMVoucher={props.timeCard.isShowTMVoucher}
                    selectedTMVoucher={props.timeCard.selectedTMVoucher}
                    tmTaskCodeList={props.timeCard.tmTaskCodeList}
                    onChangeSelectTaskCode={props.onChangeSelectTaskCode}
                    onClickTMVoucherBackBtn={props.onClickTMVoucherBackBtn}
                    onClickSelectBtn={props.onClickSelectBtn}
                />
            }

            {
                props.timeCard.isShowAttestationErrorModal &&
                <ConfirmationPopup
                    isShowConfirmation={props.timeCard.isShowAttestationErrorModal}
                    confirmationMessage={props.timeCard.attestErrorValidationMessage}
                    confirmationHeader={Constants.WARNING_HEADER_MESSAGE}
                    noText={Constants.BUTTON_BACK}
                    isShowYes={false}
                    onClickCloseBtn={() => props.openOrCloseAttestationModals(Constants.ATTESTATION_ERROR_MODAL)}
                />
            }
            {props.timeCard.isRejectedAttestation &&
                <Modal open={props.timeCard.isRejectedAttestation} closeOnDimmerClick={false} size='tiny'>
                    <Modal.Header className="text-center">Attestation Warning</Modal.Header>
                    <Modal.Content style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', paddingTop: '10px', paddingBottom: '10px', textAlign: 'justify' }}>
                        {Constants.ATTESTATION_WARNING_MESSAGE}
                    </Modal.Content>
                    <Modal.Content scrolling style={{ paddingTop: '10px', paddingBottom: '10px', minHeight: "min-content", maxHeight: "250px" }}>
                        {props.timeCard.rejectedAttestationEmployeeList.map((employeeName, i) => {
                            return <p style={{ fontWeight: 'bold' }} key={i}>{employeeName}</p>
                        })}
                    </Modal.Content>
                    <Modal.Actions className="d-flex justify-content-between">
                        <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={() => props.openOrCloseAttestationModals(Constants.ATTESTATION_CLOSE_WARNING_MODAL)}>Back</Button>
                        <Button secondary className="borderRadius w-25 mr-0" size='small' onClick={() => props.openOrCloseAttestationModals(Constants.ATTESTATION_SUBMIT_TIMECARD)}>Submit</Button>
                    </Modal.Actions>
                </Modal>
            }
            {
                props.timeCard.isShowLoader &&
                <Loader />
            }
        </Segment.Group >
    );
}

export default TimeCardComponent;

TimeCardComponent.displayName = "TimeCardComponent";